import { ProfOfferLand, RentLivingTenantRequirements } from '@search/graphql-typings';

import { getLandArea, getLandStatus, getLandSupply, getTenantsInfoB2b, getTenantsInfoB2c } from './infoHelpers';
import { mapToInformations, InfoModelRaw, InformationsEnum, TGenerateSeoUrlParams } from './infoHelpers/types/InfoModel';

export function buildInfoLand(
    land: ProfOfferLand,
    rentTenant?: RentLivingTenantRequirements | null,
    params?: {
        useLandIcon?: boolean;
        useB2cFuncs?: boolean;
        generateUrl?: (params: TGenerateSeoUrlParams) => string;
    }
) {
    const landAreaInfo = getLandArea(land);
    const informationsRaw: InfoModelRaw[] = [
        {
            title: 'Площадь участка',
            value: landAreaInfo?.landText,
            key: InformationsEnum.landArea,
            icon: params?.useLandIcon ? InformationsEnum.land : InformationsEnum.totalArea,
            extraSeoParams: {
                land: landAreaInfo?.land
            }
        },
        ...getLandStatus(land),
        ...getLandSupply(land.supply),
        ...(params?.useB2cFuncs ? getTenantsInfoB2c(rentTenant) : getTenantsInfoB2b(rentTenant))
    ];

    return mapToInformations(informationsRaw, params);
}

export function buildMainInfoLand(
    land: ProfOfferLand,
    params?: {
        useLandIcon?: boolean;
        useB2cFuncs?: boolean;
        generateUrl?: (params: TGenerateSeoUrlParams) => string;
    },
    isMobile?: boolean,
    isHouse?: boolean
) {
    const landAreaInfo = getLandArea(land);
    const informationRaw: InfoModelRaw[] = [
        {
            // eslint-disable-next-line no-nested-ternary
            title: isMobile ? (isHouse ? 'Участок' : 'Площадь') : 'Площадь участка',
            value: landAreaInfo?.landText,
            key: InformationsEnum.landArea,
            icon: params?.useLandIcon ? InformationsEnum.land : InformationsEnum.totalArea,
            extraSeoParams: {
                land: landAreaInfo?.land
            }
        },
        ...getLandStatus(land, isMobile),
    ];

    return mapToInformations(informationRaw, params);
}

export function buildAdditionalInfoLand(
    land: ProfOfferLand,
    rentTenant?: RentLivingTenantRequirements | null,
    params?: {
        useLandIcon?: boolean;
        useB2cFuncs?: boolean;
        generateUrl?: (params: TGenerateSeoUrlParams) => string;
    }
) {
    const informationRaw: InfoModelRaw[] = [
        ...getLandSupply(land.supply),
        ...(params?.useB2cFuncs ? getTenantsInfoB2c(rentTenant) : getTenantsInfoB2b(rentTenant))
    ];

    return mapToInformations(informationRaw, params);
}

